import React from "react";

const PriceInput = ({
  name,
  label,
  value,
  onChange,
  placeholder = "0.00",
  required = false,
  className = "",
  register,
  error,
  prefix = "KES",
  ...rest
}) => {
  return (
    <div className={`mb-6 ${className}`}>
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-[#636363] mb-1">
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="flex items-center rounded-md border border-[#CACACA] bg-[#F6F6F6] px-3 py-2 text-sm w-full">
        {prefix && (
          <span className="text-[#000] mr-2 font-medium select-none">{prefix}</span>
        )}
        <input
          id={name}
          name={name}
          type="text"
          inputMode="decimal"
          required={required}
          placeholder={placeholder}
          className="bg-[#F6F6F6] w-full focus:outline-none text-[#1100EF] placeholder:text-[#858585] focus:text-[#000]"
          {...(register && name ? register(name, { valueAsNumber: true }) : { value, onChange })}
          {...rest}
        />
      </div>
      {error && <p className="text-sm text-red-500 mt-1">{error.message}</p>}
    </div>
  );
};

export default PriceInput;